import React from 'react';
import {Form, Page, Button, Container, Row, Col, Spinner} from '../../components';
import {Query} from '../../utils';
import List from './list.js';
import classNames from 'classnames';
import trash from './images/trash-3.svg';
import sprintf  from 'yow/sprintf'; 
import './index.sass';
import { ButtonGroup } from 'react-bootstrap';
 
export default class extends React.Component {


    constructor(props) {
        super(props);
        this.state = {};
        this.query = new Query();
        this.state.rows = null;
        this.state.columns = [];
        this.state.selection = {};
        this.state.search = '';
        this.state.filter = '';
        this.state.sortBy = 0;
        this.state.sortOrder = 'ascending';
        this.list = React.createRef();


        this.log = console.log;
        this.debug = console.log;

        let addColumn = (column) => {
            if (typeof column == 'function')
                column = column();

            this.state.columns.push(column);
        }

        addColumn({
            name: 'Ticker',
            value: (row) => row.symbol        
        });

        addColumn({
            name: 'Namn',
            value: (row) => row.name        
        });

        addColumn({
            name: 'Branch',
            value: (row) => row.sector        
        });

        addColumn({
            name: 'Industri',
            value: (row) => row.industry        
        });

        addColumn(() => {

            let format = (date) =>  {
                if (date == null)
                    return '';
                date = new Date(date);
                return sprintf('%04d-%02d-%02d %02d:%02d', date.getFullYear(), date.getMonth()+1, date.getDate(), date.getHours(), date.getMinutes());
            }
            return ({
                name: 'Datum',
                text: (row) => format(row.timestamp),
                value: (row) => row.timestamp,
                style: {width:'12em'}

            });
        });


        
        addColumn(() => {

            return ({
                name: 'Kurs',
                value: (row) => row == undefined ? '-' : row.close,
                text: (row) => row.close.toLocaleString(),
                align:'right'
    
            });
        });






    }




    getList() {
        return this.list.current;
    }
    
    fetch() {
        try {
debugger;
            let query = `SELECT * FROM stocks LIMIT 500`;

            if (this.state.search != '') {
                query = `SELECT * FROM stocks WHERE name LIKE '%${this.state.search}%' OR symbol LIKE '%${this.state.search}%' LIMIT 500`;
            }

            this.query.fetch(query).then((rows) => {
                this.debug(`Query ${query} returned ${rows.length} results.`);
                this.setState({rows:rows});
    
            });

        }
        catch(error) {
            console.log(error.message);

        }
    }

    componentDidMount() {
        this.fetch();
    }



    renderForm() {




        let onSearchChange = async (event) => {
            let target = event.target;
            let value = target.value;
            this.setState({search:value});
        };

        let onSearchClick = (event) => {

            try {

                this.setState({rows:null});
                this.fetch();

    
            }
            catch(error) {
            }

        };

        let onKeyDown = (event) => {
            if (event.keyCode == 13) {
                onSearchClick();
            }
        }

        return (
            <Form>
                <Row>
                    <Col>
                        <Form.Control type='text' value={this.state.search} onKeyDown={onKeyDown} onChange={onSearchChange}></Form.Control>
                    </Col>
                    <Col xs='auto' className='text-end'>
                        <Button  variant="primary" onClick={onSearchClick}>Sök</Button>
                    </Col>

                </Row>
                <Row>
                    <Form.Text className="text-muted">
                        Sök efter ticker eller namn.
                    </Form.Text>
                </Row>

                <br/>


            </Form>

        );



    }

    renderList() {

        let style = {};
        style.border = 'var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)';
        style.borderRadius = 'var(--bs-border-radius)'; 
        style.height = '30rem';
        style.overflowY = 'auto';

        let onSelectionChange = (rows) => {
            console.log(rows);
        };

        let renderSpinner = () => {
            return (
                <div style={style}>
                    <div  className='d-flex justify-content-center align-items-center h-100'>
                        <Spinner className='d-flex flex-column' animation='grow'/>
                    </div>
                </div>
            );
        };

        let renderList = () => {
            return (
                <div style={style}>
                    <List
                        ref={this.list}
                        rows={this.state.rows} 
                        columns={this.state.columns} 
                        filter={this.state.filter}
                        sortBy={this.state.sortBy} 
                        sortOrder={this.state.sortOrder} 
                        onSelectionChange={onSelectionChange}
                        selectionStyle='multiple'>
                    </List>

                </div>

            );
        };


        return this.state.rows ? renderList() : renderSpinner(); 

    }


    renderFilter() {


        if (typeof this.state.filter != 'string')
            return;

        let props = {};
        props.value = this.state.filter;
        props.style = {};
        //props.style.borderColor = 'var(--bs-red)';

        props.onChange = (event) => {

            let target = event.target;
            let filter = target.value;
            let list = this.list.current;

            list.setState({filter:filter, rowFilter:list.computeRowFilter(filter)});
            this.setState({filter:filter});

        };
 
        return (
            <div className='input-group pt-2'>
                <input style={{fontSize:'90%'}} type='text' placeholder='Snabbfilter' className="form-control" {...props}></input>
            </div>        
        );        
    }

    

    renderButtons() {

        let unSelectAll = () => {
            this.list.current.select({});

        };


        return (
            <div className='text-end pt-2'>
                <Button className='m-1'>
                    Lägg till nya tickers
                </Button>
                <Button className='m-1'>
                    Ta bort markerade
                </Button>
                <Button className='m-1' onClick={unSelectAll}>
                    Avmarkera alla
                </Button>
                <Button link={-1} className='m-1'>
                    Klar
                </Button>

            </div>
        );
    }
    render() {


        return (
            <Page>
                <h4>Aktier</h4>
                {this.renderForm()}
                {this.renderList()}
                {this.renderFilter()}
                {this.renderButtons()}
            </Page>

        );



    }
}



